module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_9006.a6217149.png";